import cn from 'classnames';
import { Button, BUTTON_THEMES } from 'ht-styleguide';
import styles from './components.module.scss';

type AddDeviceButtonTypes = {
  label?: string;
  disabled?: boolean;
  className?: string;
  onClick?: BaseAnyFunction;
};

const AddDeviceButton = ({ label = 'Add another device', className, disabled, onClick }: AddDeviceButtonTypes) => (
  <Button
    icon="v2-plus-icon"
    iconClassName={cn(styles.icon, 'n900')}
    className={cn(className, styles.button)}
    theme={BUTTON_THEMES.SECONDARY}
    disabled={disabled}
    onClick={onClick}
  >
    {label}
  </Button>
);

export default AddDeviceButton;
